import React from "react";
import styled from "styled-components";

import { Form, Row, Col } from "antd";
import { Input, Button, Typography, Select } from "../core";
import { MixStyle } from "../styles";

const PaymentOption = ["check", "cash"];
const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;
const AddSizerQualityRate = ({ onCreate }) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    form.resetFields();
    onCreate(values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <StyledForm
      autocomplete="off"
      form={form}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row
        gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
        type="flex"
        justify="center"
      >
        <Col xs={24}>
          <Form.Item
            label="Quality"
            name="quality"
            rules={[
              {
                required: true,
                message: "Please select Quality",
              },
            ]}
          >
            <Select placeholder="Quality" Options={PaymentOption} />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item
            label="Rate/Kg"
            name="rate"
            rules={[
              {
                required: true,
                message: "Please Enter Rate/Kg",
              },
            ]}
          >
            <Input placeholder="Type Here" />
          </Form.Item>
        </Col>

        <Col sm={18} xs={22}>
          <Form.Item>
            <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
              <Typography
                text="Add"
                as="h5"
                noMargin
                weight="bold"
                align="center"
                color="white"
              />
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </StyledForm>
  );
};

export default AddSizerQualityRate;
